import React from "react";
import {
  GET_VISIBILITY,
  desiredOrderCVESeverity,
  cveBySeverityMap,
  FETCH_CVE_BY_SEVERITIES,
  GET_CVE_BY_SEVERITIES_DASHBOARD,
  SET_SELECTED_GROUP,
  SET_SELECTED_LABEL,
  SET_SITEMAP_EXPAND_ACCORDION,
  SET_NETSPACE_LOADER,
} from "./NetSpaceConstant";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { Box, Grid, useMediaQuery } from "material-ui-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { formatNumberUS, StyledCardHeader } from "./NetSpaceUtils";
import { sensitivityColor } from "./NetSpaceUtils";
import { PieChart, Pie, Tooltip, Cell } from "recharts";
import { CustomCard } from "./NetSpaceCommonComp";

function CveBySeverity() {
  const isSmall = useMediaQuery("(max-width:1600px)");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: GET_CVE_BY_SEVERITIES_DASHBOARD,
    });
  }, []);
  const cveBySeverity = useSelector(
    (state) => state.NetspaceReducer.cveBySeverityDashboard,
  );
  const loader = useSelector(
    (state) =>
      state.NetspaceReducer.componentLoader[GET_CVE_BY_SEVERITIES_DASHBOARD],
  );
   const reduxSelectedLabel = useSelector(
      (state) => state.NetspaceReducer?.selectedLabel,
    );
  const totalHosts = cveBySeverity
    ? Object.values(cveBySeverity).reduce((acc, curr) => acc + curr, 0)
    : 0;
  const renderContent = () => {
    if (cveBySeverity) {
      let renderEachMonitor = [];
      let pieData = [];
      const validSeverities = desiredOrderCVESeverity.filter(
        (severity) => severity in (cveBySeverity || {}),
      );
      validSeverities.forEach((monitor) => {
        const color =
          monitor === "CRITICAL" ? "#e22d1b" : sensitivityColor(monitor);

        renderEachMonitor.push(
          <Grid item xs={12} key={monitor}>
            <div
              className={`clickable-label ${monitor}`}
              style={{ color }}
              onClick={() => {
                const isSameLabel = reduxSelectedLabel === monitor;

                dispatch({
                  type: SET_NETSPACE_LOADER,
                  payload: true,
                });

                dispatch({
                  type: SET_SITEMAP_EXPAND_ACCORDION,
                  payload: {},
                });

                if (isSameLabel) {
                  dispatch({
                    type: SET_SELECTED_LABEL,
                    payload: null,
                  });

                  return;
                }

                dispatch({
                  type: SET_SELECTED_GROUP,
                  payload: {
                    group: "VULNERABILITIES",
                    place: "non-widget",
                  },
                });

                dispatch({
                  type: SET_SELECTED_LABEL,
                  payload: monitor,
                });
              }}
            >
              {formatNumberUS(cveBySeverity[monitor])}{" "}
              {cveBySeverityMap[monitor]}
            </div>
          </Grid>,
        );

        pieData.push({
          name: monitor,
          value: cveBySeverity[monitor],
          color: sensitivityColor(monitor),
        });
      });

      if (renderEachMonitor.length === 0) {
        return <div>No Data Available</div>;
      }

      return (
        <div className="a-tag-none">
          <Grid container direction="row" spacing={2}>
            <div className="netspace-common-container-class">
              <div className="netspace-value-container cveSeverity">
                {renderEachMonitor.map((item, i) => (
                  <React.Fragment key={i}>{item}</React.Fragment>
                ))}
              </div>

              <Grid item xs={6}>
                <Box
                  sx={{
                    width: isSmall ? 120 : 150,
                    height: isSmall ? 100 : 120,
                  }}
                >
                  <PieChart
                    className="netspace-card-pie"
                    width={isSmall ? 130 : 150}
                    height={isSmall ? 100 : 120}
                  >
                    <Pie
                      isAnimationActive={false}
                      data={pieData}
                      nameKey="name"
                      dataKey="value"
                    >
                      {pieData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry["color"]} />
                      ))}
                    </Pie>
                    <Tooltip wrapperClassName="custom-tooltip" />
                  </PieChart>
                </Box>
              </Grid>
            </div>
          </Grid>
        </div>
      );
    }

    return <div>No Data Available</div>;
  };
  return (
    <>
      <Grid item xs={2}>
        <CustomCard color="white">
          <div className="common-widget-title">
            <StyledCardHeader
              title={`Vulnerabilities: ${formatNumberUS(totalHosts)}`}
            />
          </div>
          <CardContent className="card-content">
            {loader ? (
              <img src={Page_Loader} alt="loading" className="loader-img"></img>
            ) : (
              renderContent()
            )}
          </CardContent>
        </CustomCard>
      </Grid>
    </>
  );
}

export default CveBySeverity;
